import React from 'react';
import { useSubscriberProfile } from '@subflow/data-access';
import { CustomAvatar } from '@subflow-frontend/components/avatars/CustomAvatar';
import { formatSubscriberName } from '@subflow-frontend/utils/subscriber';

export const MySubscriberAvatar: React.FC = () => {
  const { data: subscriber } = useSubscriberProfile();

  return (
    <CustomAvatar
      profileName={formatSubscriberName(
        subscriber?.firstName,
        subscriber?.lastName
      )}
      profileLoaded={!!subscriber}
      profileImage={subscriber?.avatar}
    />
  );
};
